import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

// Import translations
import en from '@/locales/en/translation.json'
import uk from '@/locales/uk/translation.json'

const resources = {
  en: {
    translation: en,
  },
  uk: {
    translation: uk,
  },
}

i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources,
    fallbackLng: 'uk', // Default language
    supportedLngs: ['en', 'uk'],
    debug: false,
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

export default i18n
